<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="푸시 알림 전송 목록"
      desc="푸시 알림 전송 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push('push/create')"
              class="button is-primary">푸시 알림 전송</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="title" slot-scope="props">
        <div class="unselect" style="text-decoration: underline"
          @click="$router.push(`push/create?id=${props.item.id}`)">{{ props.item.title }}</div>
      </div>

      <div slot="device" slot-scope="props">{{ props.item.device === '' ? '전체' : props.item.device }}</div>

      <div slot="target" slot-scope="props">
        {{ props.item.target===0? '일반회원':props.item.target===2?'마케팅정보수신동의회원':props.item.target }}
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'PushList',
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalItem: 0
      }
    },

    created () {
      this.init();
    },
    methods: {
      init () {
        this.initializing('push', 'push');
      },
      getDataFromServer() {
        this.getData();
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>

</style>
